module.exports = __webpack_public_path__ + "static/media/avatar_47.35df8940.svg";